import * as urls from './url';
import axios from 'axios';

axios.defaults.baseURL = urls.baseUrl;

// 개발시 API 호출 및 응답 확인용
if (process.env.NODE_ENV === 'development') {
  axios.interceptors.request.use(request => {
    console.log(request);
    // Edit request config
    // request.headers.common['Authorization'] = token;
    return request;
  }, error => {
    console.error(error);
    return Promise.reject(error);
  });
  axios.interceptors.response.use(response => {
    console.log(response);
    // Edit response config
    return response;
  }, error => {
    console.error(error);
    return Promise.reject(error);
  });
}

// ================================================================================================================ //
// for Java API
export function googleLogin() {
  location.href = urls.googleLogin;
}

export function logout(cb) {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return;
  }

  axios.get(urls.logout, {
    headers: {
      access_token: accessToken,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getHistory(cb) {
  axios.get(urls.getLogs, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getProfile(cb) {
  axios.get(urls.getProfile, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function admins(cb) {
  axios.get(urls.admins, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function checkRoles(cb) {
  axios.get(urls.checkRoles, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getRoles(cb) {
  axios.get(urls.roles, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getServiceRegion(cb) {
  axios.get(urls.getServiceRegion, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getRoleDetail(roleId, cb) {
	  axios.get(urls.getRoleDetail, {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {
	      roleId,
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}


export function getRoleGroupDetail(roleGroupId, cb) {
  axios.get(urls.getRoleGroupDetail, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      roleGroupId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateRoleGroup(roleGroupId, roleGroupName, roleGroupKey, roleGroupDescription, roleLocalePairs, cb) {
  axios.post(urls.updateRoleGroup, {
    roleGroupId,
    roleGroupName,
    roleGroupKey,
    roleGroupDescription,
    roleLocalePairs,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateRole(role, cb) {
	  axios.post(urls.updateRole, role, {
	    headers: {
	      access_token: getAccessToken(),
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
	}


export function getSubscriptionStatus(cb) {
  axios.get(urls.getSubscriptionStatus, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data.status);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function preSubscriptions(search, cb) {
  axios.post(urls.preSubscriptions, search, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function updatePreSubscription(preSubscription, cb) {
  axios.post(urls.updatePreSubscription, preSubscription,
      {
        headers: {
          access_token: getAccessToken(),
        },
      }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function deletePreSubscription(id, cb) {
  axios.delete(urls.deletePreSubscription,
      {
        headers: {
          access_token: getAccessToken(),
        },
        params: {id}
      }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function uploadPreSubscription(file, cb) {
  axios.post(urls.uploadPreSubscription, file,
      {
        headers: {
          access_token: getAccessToken(),
          'content-type': 'multipart/form-data'
        },
      }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function getSubscriptionProductTypes(subscriptionProductType, cb) {
  axios.get(urls.getSubscriptionProductTypes, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      subscriptionProductType,
    },
  }).then(response => {
    cb(null, response.data.subscriptionProductType);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function createProduct(productData, formData, cb) {
  axios.post(urls.createProduct, formData, {
    headers: {
      access_token: getAccessToken(),
      'Content-Type': 'multipart/form-data',
    },
    params: {
      ...productData,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateProduct(productData, formData, cb) {
  axios.post(urls.updateProduct, formData, {
    headers: {
      access_token: getAccessToken(),
      'Content-Type': 'multipart/form-data',
    },
    params: {
      ...productData,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getSubscriptionProduct(subscriptionProductId, cb) {
  axios.get(urls.getSubscriptionProduct, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      subscriptionProductId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getPatientName(email, cb) {
  axios.get(urls.getPatientName, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      email,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function getPatientsList(search, cb) {
  axios.post(urls.getPatientsList, search, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getPatientDetail(patientId, cb) {
  axios.get(urls.getPatientDetail, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      patientId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function getPaymentDetail(contractId, cb) {
  axios.get(urls.getPaymentDetail, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      contractId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getUserList(search, cb) {
  axios.post(urls.getUserList, search, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updatePatientInfo(patient, cb) {
  axios.post(urls.updatePatientInfo, patient, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function resetPassword(patientId, cb) {
  let data = new FormData();
  data.append('patientId',patientId);

  axios.post(urls.resetPassword, data, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}




export function updatePatientSubscription(data, cb) {
  axios.post(urls.updatePatientSubscription, data, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function deletePayment(paymentId, cb) {
  axios.post(urls.deletePayment, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      paymentId
    }
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function savePayment(data, cb) {
  axios.post(urls.savePayment, data, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function updateInstallmentPeriod(data, cb) {
  axios.post(urls.updateInstallmentPeriod, data, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateInstallmentAmount(data, cb) {
  axios.post(urls.updateInstallmentAmount, data, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function createFreePatientSubscription(patientId, cb) {
  axios.post(urls.createFreePatientSubscription, {
    patientId,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getClinicianList(search, cb) {
  axios.post(urls.getClinicianList, search, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getPatientListForMapping(search, cb) {
  axios.post(urls.getPatientListForMapping, search, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getPatientClinicianMapping(clinicianId, cb) {
  axios.get(urls.getPatientClinicianMapping, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      clinicianId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getClinicianPatientMapping(patientId, cb) {
	  axios.get(urls.getClinicianPatientMapping, {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {
	      patientId,
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
	}


export function mapPatientToClinicians(patientId, clinicianIds, cb) {
	  axios.post(urls.mapPatientToClinicians, {
		  patientId,
		  clinicianIds,
	  }, {
	    headers: {
	      access_token: getAccessToken(),
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}


export function mapClinicianToPatients(clinicianId, patientIds, cb) {
  axios.post(urls.mapClinicianToPatients, {
    clinicianId,
    patientIds,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getServiceName(serviceTypeName, cb) {
  axios.get(urls.getServiceName, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      serviceTypeName,
    },
  }).then(response => {
    cb(null, response.data.serviceType);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function createAssetVersion(version, serviceTypeName, cb) {
  axios.post(urls.createAssetVersion, {
    version,
    serviceTypeName,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getAssetVersions(serviceType, cb) {
  axios.get(urls.getAssetVersions, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      serviceTypeName: serviceType,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getAssetFileList(assetVersionId, cb) {
  axios.get(urls.getAssetFileList, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      assetVersionId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function deleteAsset(assetNAssetVersionIds, cb) {
  axios.delete(urls.deleteAsset, {
    headers: {
      access_token: getAccessToken(),
    },
    data: {
      assetNAssetVersionIds,
    },
  }).then(() => {
    cb(null);
  }).catch(error => {
    console.error(error);
    cb(error);
  });
}

export function uploadAssetJson(file, cb) {
	  axios.post(urls.uploadAssetJson, file,
	    {
	    headers: {
	      access_token: getAccessToken(),
	      'content-type': 'multipart/form-data'
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function copyAssets(fromAssetVersionId, toAssetVersionId, type, cb) {
  axios.get(urls.copyAssets, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      fromAssetVersionId,
      toAssetVersionId,
      type,
    },
  }).then(response => {
    cb(null, response.data.list);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getAdmin(adminUserId, cb) {
  axios.get(urls.getAdmin, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      adminUserId,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getRoleGroups(cb) {
  axios.get(urls.getRoleGroups, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data.roleGroups);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateAdminUser(adminUserId, adminUserName, roleGroupIds, cb) {
  axios.post(urls.updateAdminUser, {
    adminUserId,
    adminUserName,
    roleGroupIds,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function createContract(contract, cb) {
  axios.post(urls.createContract, {
    ...contract,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateContractProduct(contractId, medicalDevice, cb) {
  axios.post(urls.updateContractProduct,{}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      contractId,
      medicalDevice: JSON.stringify(medicalDevice)
    }
   }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}




export function getContractList(patientId, cb) {
  axios.get(urls.contractList, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      patientId,
    },
  }).then(response => {
    cb(null, response.data.list);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateSerialNo(contractId, serialNo, cb) {
  axios.post(urls.updateSerialNo, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {contractId, serialNo}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function updateOpportunityLink(contractId, opportunityLink, cb) {
  axios.post(urls.updateOpportunityLink, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {contractId, opportunityLink}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function updateBillingDate(contractId, nextPaymentDate, cb) {
  axios.post(urls.updateBillingDate, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {contractId, nextPaymentDate}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function charge(amount, contractId, cb) {
  axios.post(urls.charge, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {amount, contractId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function updatEexpectedPaymentMonth(paymentId, expectedPaymentMonth, cb) {
  axios.post(urls.updatEexpectedPaymentMonth, {}, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {paymentId, expectedPaymentMonth}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function cancelContract(contractId, cb) {
  axios.post(urls.cancelContract, {
    contractId,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function activateContract(contractId, cb) {
  axios.post(urls.activateContract, {
    contractId,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function refund(paymentId, amount, reason, cb) {
  axios.post(urls.refund, {
    paymentId,
    amount,
    reason,
  }, {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getPaymentList(page, cb) {
  axios.post(urls.paymentHistory, page,
    {
    headers: {
      access_token: getAccessToken()
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function downloadPaymentList(page, fileName) {
  axios.post(urls.downloadPaymentHistory, page,
      {
        headers: {
          access_token: getAccessToken()
        },
        responseType: 'blob'
      }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'paymentlist.xlsx');
          document.body.appendChild(link);
          link.click();
    }).catch(error => {
       console.error(error);
    });
}

export function checkEmail(email, cb) {
  axios.get(urls.checkEmail, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {
      email,
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getMessageCodes(page, cb) {
  axios.post(urls.messageCodes, page,
    {
    headers: {
      access_token: getAccessToken()
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getMessageCode(messageCodeId, cb) {
  axios.get(urls.messageCode, {
    headers: {
      access_token: getAccessToken()
    },
    params: {messageCodeId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getMessageTexts(messageCodeId, cb) {
  axios.get(urls.messageTexts, {
    headers: {
      access_token: getAccessToken(),
    },
    params: {messageCodeId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateMessage(message, cb) {
  axios.post(urls.updateMessage, message,
    {
    headers: {
      access_token: getAccessToken(),
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function deleteMessageCode(messageCodeId, cb) {
  axios.delete(urls.deleteMessageCode,
    {
    headers: {
      access_token: getAccessToken(),
    },
    params: {messageCodeId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function uploadMessages(file, cb) {
  axios.post(urls.uploadMessage, file,
    {
    headers: {
      access_token: getAccessToken(),
      'content-type': 'multipart/form-data'
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function uploadBulkMessages(file, cb) {
  axios.post(urls.uploadBulkMessage, file,
      {
        headers: {
          access_token: getAccessToken(),
          'content-type': 'multipart/form-data'
        },
 }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getRapaelClients(page, cb) {
  axios.post(urls.rapaelClients, page,
    {
    headers: {
      access_token: getAccessToken()
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function getRapaelClient(rapaelClientId, cb) {
  axios.get(urls.rapaelClient, {
    headers: {
      access_token: getAccessToken()
    },
    params: {rapaelClientId: rapaelClientId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function updateRapaelClient(rapaelClient, cb) {
  axios.post(urls.updateRapaelClient, rapaelClient,
    {
    headers: {
      access_token: getAccessToken(),
      'content-type': 'multipart/form-data'
    },
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function uploadRapaelClient(file, cb) {
	  axios.post(urls.uploadRapaelClient, file,
	    {
	    headers: {
	      access_token: getAccessToken(),
	      'content-type': 'multipart/form-data'
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function deleteRapaelClient(rapaelClientId, cb) {
  axios.delete(urls.deleteRapaelClient,
    {
    headers: {
      access_token: getAccessToken(),
    },
    params: {rapaelClientId: rapaelClientId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}


export function activateRapaelClient(rapaelClientId, cb) {
  axios.post(urls.activateRapaelClient, {},
    {
    headers: {
      access_token: getAccessToken(),
    },
    params: {rapaelClientId: rapaelClientId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}

export function inactivateRapaelClient(rapaelClientId, cb) {
  axios.post(urls.inactivateRapaelClient, {},
    {
    headers: {
      access_token: getAccessToken(),
    },
    params: {rapaelClientId: rapaelClientId}
  }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



export function getContentClient(contentClientId, cb) {
	  axios.get(urls.contentClient,
	    {
	    headers: {
	      access_token: getAccessToken()
	    },
	    params: {contentClientId: contentClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function getContentClients(rapaelClientId, cb) {
	  axios.get(urls.contentClients, {
	    headers: {
	      access_token: getAccessToken()
	    },
	    params: {rapaelClientId: rapaelClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function updateContentClient(contentClient, cb) {
	  axios.post(urls.updateContentClient, contentClient,
	    {
	    headers: {
	      access_token: getAccessToken(),
	      'content-type': 'multipart/form-data'
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function deleteContentClient(contentClientId, cb) {
	  axios.delete(urls.deleteContentClient,
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentClientId: contentClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}






export function activateContentClient(contentClientId, cb) {
	  axios.post(urls.activateContentClient, {},
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentClientId: contentClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
	}

export function inactivateContentClient(contentClientId, cb) {
	  axios.post(urls.inactivateContentClient, {},
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentClientId: contentClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}



export function getContentMeta(contentMetaId, cb) {
	  axios.get(urls.contentMeta,
	    {
	    headers: {
	      access_token: getAccessToken()
	    },
	    params: {contentMetaId: contentMetaId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function getContentMetas(rapaelClientId, cb) {
	  axios.get(urls.contentMetas, {
	    headers: {
	      access_token: getAccessToken()
	    },
	    params: {rapaelClientId: rapaelClientId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function updateContentMeta(contentMeta, cb) {
	  axios.post(urls.updateContentMeta, contentMeta,
	    {
	    headers: {
	      access_token: getAccessToken()
	    },
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}

export function deleteContentMeta(contentMetaId, cb) {
	  axios.delete(urls.deleteContentMeta,
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentMetaId: contentMetaId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}





export function activateContentMeta(contentMetaId, cb) {
	  axios.post(urls.activateContentMeta, {},
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentMetaId: contentMetaId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
	}

export function inactivateContentMeta(contentMetaId, cb) {
	  axios.post(urls.inactivateContentMeta, {},
	    {
	    headers: {
	      access_token: getAccessToken(),
	    },
	    params: {contentMetaId: contentMetaId}
	  }).then(response => {
	    cb(null, response.data);
	  }).catch(error => {
	    console.error(error);
	    cb(error, null);
	  });
}





export function getAccessToken() {
  return localStorage.getItem('access_token');
}

export function updateCard(contractId, paymentId, cb) {
  axios.post(urls.updateCreditCard, {},
      {
        headers: {
          access_token: getAccessToken(),
        },
        params: {
          contractId,
          paymentId
        }
      }).then(response => {
    cb(null, response.data);
  }).catch(error => {
    console.error(error);
    cb(error, null);
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js